<template>
  <v-carousel
      :class="isXs?'rounded-lg ma-5':'rounded-lg mt-5 mb-5 mx-16'"
      cycle
      :height="isXs?100:300"
      hide-delimiter-background
      hide-delimiters
      :show-arrows="false"
  >
    <v-carousel-item
        v-for="item in items"
        :href="item.link"
        target="_blank"
        :src="item.image"
    ></v-carousel-item>
  </v-carousel>

</template>
<script>

export default {
  name: "HomeBanner",
  mixins: [],
  data() {
    return {};
  },
  computed: {
    items() {
      return [
        {
          link: "https://exuni.ir/product-category/home-and-kitchen-appliances/",
          image: "/img/Home-Kitchen.jpg"
        },
        {
          link: "https://exuni.ir/product-category/cosmetics-health/health/sexual-health/",
          image: "/img/Sexual-Health.jpg"
        },
        {
          link: "https://exuni.ir/product-tag/exuni-suggested-pack/",
          image: "/img/Skin-Care.jpg"
        },

      ];
    },
  },
  mounted() {
  },
  methods: {
    routeClick(routeName) {
      this.$router.push({name: routeName})
    },

  },
};
</script>
<style>

</style>
